module.exports = __webpack_public_path__ + "static/media/auth-bg.606b6967.jpg";